(function ($) {


    function showTooltip($tooltipEl) {
        if(!$tooltipEl.length) return;

        hideTooltip();

        const tooltipTextClientBoundRect = $tooltipEl.find('.feat-table__tooltip__text').get(0).getBoundingClientRect();

        if (tooltipTextClientBoundRect.y < 100) {
            $tooltipEl.addClass('feat-table__tooltip--open-bottom')
        }

        $tooltipEl.addClass('feat-table__tooltip--opened');
    }



    function hideTooltip() {
        $('.feat-table__tooltip').removeClass('feat-table__tooltip--opened').removeClass('feat-table__tooltip--open-bottom');
    }


    $(document).on('ready', function () {

        $('.feat-table__tooltip--btn').on('click', function () {
            showTooltip($(this));
        });


        $('body').on('click', function (e) {
            if ( !($(e.target).closest('.feat-table__tooltip').length > 0) ) {
                hideTooltip();
            }
        });

    });


})(jQuery);